export const INSTAGRAM = 'INSTAGRAM'
export const FACEBOOK = 'FACEBOOK'
export const GOOGLE = 'GOOGLE'

export const TWITTER = 'TWITTER'
export const TUMBLR = 'TUMBLR'
export const GITHUB = 'GITHUB'

export const VK = 'VK'
export const GMAIL = 'GMAIL'
export const WECHAT = 'WECHAT'

export const AMAZON = 'AMAZON'
export const LINKEDIN = 'LINKEDIN'
export const WHATSAPP = 'WHATSAPP'
